import Firefly1 from "../images/researchprojects/project-firefly/C1.jpg";
import Firefly2 from "../images/researchprojects/project-firefly/C2.jpg";
import Firefly3 from "../images/researchprojects/project-firefly/C3.jpg";
import Firefly4 from "../images/researchprojects/project-firefly/C4.jpg";
import Firefly5 from "../images/researchprojects/project-firefly/C5.jpg";
import Firefly6 from "../images/researchprojects/project-firefly/C6.jpg";
import Firefly7 from "../images/researchprojects/project-firefly/C7.jpg";
import Firefly8 from "../images/researchprojects/project-firefly/C8.jpg";
import Firefly9 from "../images/researchprojects/project-firefly/C9.jpg";
import Firefly10 from "../images/researchprojects/project-firefly/C10.jpg";
import Firefly11 from "../images/researchprojects/project-firefly/C11.jpg";
import Firefly12 from "../images/researchprojects/project-firefly/C12.jpg";
import Firefly13 from "../images/researchprojects/project-firefly/C13.jpg";
import Firefly14 from "../images/researchprojects/project-firefly/C14.jpg";
import Tool1 from "../images/researchprojects/computational-tool/C1.png";
import Tool2 from "../images/researchprojects/computational-tool/C2.png";
import Tool3 from "../images/researchprojects/computational-tool/C3.png";
import Tool4 from "../images/researchprojects/computational-tool/C4.png";
import Tool5 from "../images/researchprojects/computational-tool/C5.png";
import Tool6 from "../images/researchprojects/computational-tool/C6.png";
import Tool7 from "../images/researchprojects/computational-tool/C7.png";
import Tool8 from "../images/researchprojects/computational-tool/C8.png";
import HealthcareUROP from "../images/researchprojects/healthcare-urop.png";
import Placeholder from "../images/placeholder.png";

export const researchProjects = [
  {
    id: "neural-prostheses",
    img: Placeholder,
    carouselData: [],
    title: "Introduction To Neural Prostheses/Neural Assistive Devices",
    year: "May 2023 - Oct 2023",
    description:
      "This project was initiated by fellow student Maathavan Manimaran and supervised by Dr Khoo Xiaojuan. It aimed to build a research database that would enable the development of a prototype neural prosthesis that can successfully be integrated with the human nervous system through computer and brain interfacing. I worked on identifying the limitations or fallacies in existing research, and discussed and reviewed research articles related to the field of study.",
    github: "",
    report: "",
    type: "Research",
    youtube: ""
  },
  {
    id: "privacy-preservation",
    img: Placeholder,
    carouselData: [],
    title: "Privacy Preservation Project",
    year: "Feb 2023 - Jun 2023",
    description:
      "This project was done under NCLab, a ubiquitous computing research lab under the supervision of Professor Junehwa Song in KAIST. I developed an Android application that aims to preserve the privacy of visually impaired people while others are assisting them in tasks. I also utilised GPT-3.5 APIs to aid the censoring of sensitive information.",
    github: "",
    report: "",
    type: "Research",
    youtube: "",
  },
  {
    id: "project-firefly",
    img: Firefly11,
    carouselData: [
      { image: Firefly1 },
      { image: Firefly2 },
      { image: Firefly3 },
      { image: Firefly4 },
      { image: Firefly5 },
      { image: Firefly6 },
      { image: Firefly7 },
      { image: Firefly8 },
      { image: Firefly9 },
      { image: Firefly10 },
      { image: Firefly11 },
      { image: Firefly12 },
      { image: Firefly13 },
      { image: Firefly14 },
    ],
    title: "Project Firefly",
    year: "2022",
    description:
      "This project was done under the supervision of Dr Kenny Choo. In collaboration with SOS, an application for SOS CareText allowing for 2-way text messaging, conversation support using AI, and live-text logging is being developed. I designed UI prototypes for the application using Figma and conducted literature review on Natural Language Processing models.",
    github: "",
    report:
      "https://www.figma.com/proto/XWeKf4LYhSDaUUoOhVbv0H/Project-Firefly?page-id=129%3A2&node-id=129%3A107&viewport=432%2C111%2C0.05&scaling=contain&starting-point-node-id=129%3A901&show-proto-sidebar=1",
    type: "Research",
    youtube: ""
  },
  {
    id: "healthcare-shortform-videos",
    img: HealthcareUROP,
    carouselData: [],
    title:
      "Harnessing Short-form Videos To Deliver Educational Healthcare-related Content To Young Singaporeans",
    year: "Sep 2021 - Dec 2022",
    github: "",
    report: "",
    type: "Research",
    description: "This project was a student-initiated project, done under the supervision of Dr Chandrima Chatterjee and Dr Bong Eng Ying. We aimed to evaluate the effectiveness of our novel healthcare-related videos on social media platforms in educating and spreading awareness on adopting a healthier lifestyle to 18-24-year-old Singaporean students. An Instagram page (<a className=\"text-green dark:text-green-dark underline underline-offset-2\" href=\"https://instagram.com/a.healthcare.urop\" target=\"_blank\" and rel=\"noopener noreferrer\">@a.healthcare.urop</a>), TikTok account (<a className=\"text-green dark:text-green-dark underline underline-offset-2\" href=\"https://www.tiktok.com/@a.healthcare.urop\" target=\"_blank\" and rel=\"noopener noreferrer\">@a.healthcare.urop</a>) and a <a className=\"text-green dark:text-green-dark underline underline-offset-2\" href=\"https://www.youtube.com/channel/UC8629phSkFH16j7cKslhW_Q\" target=\"_blank\" and rel=\"noopener noreferrer\">YouTube account</a> were created to post these videos.",
    youtube: ""
  },
  {
    id: "expressive-avatars",
    img: Placeholder,
    carouselData: [],
    title: "Expressive Avatars To Reduce Social Anxiety In Therapy",
    year: "May 2021 - Sep 2021",
    description:
      "This project was done under the supervision of MIbD student Ethan Lim Swee Hao and Dr Kenny Choo. It aimed to realise avatar interaction as a viable alternative medium to deliver psychotherapy intervention. I researched on the scientific and technological aspects of Heart Rate Variability (HRV) measurement softwares to understand the biological/physiological relations to HRV, and the scientific concepts behind the various calculations, assisted in the setting up of and participation in a research study involving two 30 min interactions with a counsellor (one with an avatar and one without an avatar), and ran statistical tests to validate the HRV measurements from CorSense and Polar H10 sensors using JMP.",
    github: "",
    report:
      "https://drive.google.com/drive/folders/1IA3JcvC9WBvKTzycDPNd0c6BsZ1jegD3?usp=sharing",
    type: "Research",
    youtube: ""
  },
  {
    id: "computational-tool-biomedical",
    img: Tool6,
    carouselData: [
      { image: Tool1 },
      { image: Tool2 },
      { image: Tool3 },
      { image: Tool4 },
      { image: Tool5 },
      { image: Tool6 },
      { image: Tool7 },
      { image: Tool8 },
    ],
    title: "Computational Tool for Biomedical Data Analysis",
    year: "May 2021 - Aug 2021",
    description:
      "This project was done under the supervision of Asst Prof Yeo Si Yong. It aimed to predict cardiac health from input data (patient demographics, metabolomics data and exercises) with machine learning. I conducted a literature review on existing projects involving machine learning in cardiac health and implemented a deep learning model, Multi-Layer Perceptron, after extensive pre-processing of the given dataset of 90 data points in 3 weeks.",
    github: "",
    report:
      "https://drive.google.com/drive/folders/1I9oV-hqccIVkmzOxgGu7m4vot9ghIFOz",
    type: "Research",
    youtube: ""
  },
  {
    id: "growth-spine-implants",
    img: Placeholder,
    carouselData: [],
    title:
      "Design Opportunities Identification: Growth and Motion Preserving Spine Implants to Correct Scoliosis In Children",
    year: "Jan 2021 - May 2021",
    description:
      "This project was done under the supervision of Asst Prof Subburaj Karupppasamy. It aimed to identify potential design opportunities for new innovative growth-sparing spine implants to correct scoliosis in children.",
    github: "",
    report: "",
    type: "Research",
    youtube: ""
  },
  {
    id: "patient-output-inspection",
    img: Placeholder,
    carouselData: [],
    title: "Patient Output Inspection with AI",
    year: "May 2020 - Sep 2020",
    description:
      "This project was done under the supervision of Assoc Prof Chau Yuen. It aimed to classify stool samples according to the Bristol Stool Scale using image processing and CNN techniques. Through this project, I explored various methods (WaveletCNN, Local Binary Patterns and Histogram Layers) for texture classification of images with around 70-80% accuracy, and implemented transfer learning methods for machine learning (NASNet-Large) to allow for an automatic algorithm that could perform output inspection based on the Bristol stool scale with around 70% accuracy.",
    github: "",
    report: "",
    type: "Research",
    youtube: ""
  },
];